export { BfxInputControlStateEnum } from "shared/base-components/models/base-components.enums";

/* AUTOCOMPLETE ENUMS */
export enum BfxAutocompleteModeEnum {
  TYPE,
  CLIENT,
  ACCOUNT,
  CLIENT_TRADER,
}
export enum BfxAutocompleteFavoriteTypeEnum {
  CLIENT,
  ACCOUNT,
  CCY_PAIR,
}
export enum BfxAutocompleteFavoriteItemFormatEnum {
  RAW,
  MODEL,
  DISPLAY,
}
